import React, { FC, useEffect } from 'react';
import { CommonAppProviders } from '../../app/common-app/CommonAppProviders';
import { displayCookieBannerWhenNeeded } from '../../cookies/handleCookiesPolicy';
import { useShowLogin } from './useShowLogin';

const PublicConsumersUses: FC = () => {
  useShowLogin();
  return null;
};

export const PublicCommon: FC = ({ children }) => {
  useEffect(() => {
    displayCookieBannerWhenNeeded();
  }, []);

  return (
    <CommonAppProviders isLoggedIn={window.logged_in}>
      <PublicConsumersUses />
      {children}
      <div data-react="cookies-banner" data-nosnippet />
    </CommonAppProviders>
  );
};
